import React from "react"

export default function Header() {
    return (
        <header className="header">
            <img 
                src="https://picsum.photos/640/360" 
                className="header--image"
            />
            <h2 className="header--title">Meme Generator</h2>
            <h4 className="header--project">Get your MEME</h4>
        </header>
    )
}